import httpService from '@/utils/request'
import { contextPath } from '@/config/'

// 列表
export const getIpPoolList = (params) => {
  return httpService({
    url: contextPath + '/ip-pool/info',
    method: 'get',
    params
  })
}

// 新增
export const addIpPool = (data) => {
  return httpService({
    url: contextPath + '/ip-pool/item',
    method: 'post',
    data
  })
}

// 详情
export const getIpPool = (data) => {
  return httpService({
    url: contextPath + '/ip-pool/item',
    method: 'get',
    data
  })
}

// 编辑
export const editIpPool = (data) => {
  return httpService({
    url: contextPath + '/ip-pool/item',
    method: 'put',
    data
  })
}

// 删除
export const deleteIpPool = (params) => {
  return httpService({
    url: contextPath + '/ip-pool/item',
    method: 'delete',
    params
  })
}

// 修改状态
export const editIpPoolStatus = (data) => {
  return httpService({
    url: contextPath + '/ip-pool/item/updateStatus',
    method: 'put',
    data
  })
}
